import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import type { IResponseEventUpdateBalance } from 'entities/Organization/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventUpdateBalance = () => {
  const { organizationStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventUpdateBalance) => {
    organizationStore.updateBalance(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.AccountBalanceUpdated, handle), [])
}
